module.exports=function(scope){ return `<!-- idScan match successful -->
{
    "data": {
        "glasses": false,
        "faceMapAgeEstimateGroup": 4,
        "digitalSpoofStatus": 0,
        "matchLevel": 5,
        "fullIDStatus": 0,
        "livenessStatus": 0,
        "enrollmentIdentifier": "testEnrollmentIdentifier",
        "idScanAgeEstimateGroup": 4,
        "message": "The /id-check request was processed and the Match Level was 5",
        "isLowQuality": false,
        "tid": "..."
    },
    "meta": {
        "code": 200,
        "ok": true,
        "message": "The /id-check request was processed and the Match Level was 5"
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/success/id-check.json.tpl